"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplashScreen = void 0;
const zimporter_phaser_1 = require("zimporter-phaser");
const GlobalData_1 = require("./GlobalData");
const LoadingBar_1 = require("./LoadingBar");
const StoryLoader_1 = require("./StoryLoader");
class SplashScreen {
    constructor(phaserScene, onComplete) {
        this.phaserScene = phaserScene;
        this.onComplete = onComplete;
        this.scene = new zimporter_phaser_1.ZScene('splash', phaserScene);
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            const bar = new LoadingBar_1.LoadingBar(this.phaserScene);
            // Load splash scene visuals and story XML simultaneously
            yield Promise.all([
                new Promise(resolve => {
                    this.scene.load(`${GlobalData_1.GlobalData.assetsBasePath}Splash/`, () => {
                        bar.remove();
                        resolve();
                    });
                }),
                StoryLoader_1.StoryLoader.load(GlobalData_1.GlobalData.currentLang),
            ]);
            this.scene.loadStage(this.phaserScene);
            // Auto-play any timeline animations in the splash scene
            const children = this.scene.sceneStage.list;
            for (const child of children) {
                if (child instanceof zimporter_phaser_1.ZTimeline) {
                    child.play();
                }
            }
            // Show splash for 2 s, then signal Game to begin the next scene.
            // Destruction is deferred to Game.ts so the splash stays visible
            // while the next scene is loading.
            setTimeout(() => { this.onComplete(); }, 2000);
        });
    }
    /** Called by Game.ts after the next scene has finished loading. */
    destroy() {
        // Only remove and destroy the display objects — calling scene.destroy()
        // may spawn internal async tasks.
        if (this.scene.sceneStage.parentContainer) {
            this.scene.sceneStage.parentContainer.remove(this.scene.sceneStage);
        }
        this.scene.sceneStage.destroy();
    }
}
exports.SplashScreen = SplashScreen;
